export default "__VITE_ASSET__C69m1tNH__"